<div class="overflow-y-auto h-full use-scrollbar">
  @if (!!resultButtons && resultButtons.length > 0) {
    <app-detailed-result-buttons
      [buttons]="resultButtons"
      [focusInitialOnFirst]="!!isMobile"
      class="pb-4"
      />
  }

  <app-tariff-profile-selector class="px-4" (onToggleChange)="togglePriceCalculation($event)"
    [priceCalculationLabel]="priceCalculationLabel" [showRoutePrice]="showRoutePrice"
    [priceProfileFormControl]="tariffProfileFormControl" [dir]="direction" />

    <!-- <app-tariff-profile-selector (onToggleChange)="togglePriceCalculation()"
    [priceCalculationLabel]="priceCalculationLabel" [showRoutePrice]="showRoutePrice" [dir]="direction"
    [priceProfileFormControl]="priceProfileFormControl" /> -->

    <form [formGroup]="calendarPickForm" class="p-4 pt-0 flex flex-col gap-6">
      <div id="calendar-pick-container">
        <h3 class="text-base !mt-0">{{ pickDayAndTimeText }}</h3>

        <div class="flex gap-2 pb-4">
          <mot-date-picker formControlName="day" [label]="dayText" [minDate]="minDate" [maxDate]="maxDate"
            [displayErrors]="false" class="text-start w-full" style="width: 50%" />
            <mot-time-picker formControlName="time" [label]="timeText" class="w-full" icon="clock"
              iconClass="text-2xl" style="width: 50%" />
            </div>
            @if (stopsChanged) {
              <span class="text-sm text-red-500 block mt-1">{{stopsChangedText}}</span>
            }
          </div>

          <app-search-line-detailed-stops [stops]="line.stops" [boardingStationSeq]="boardingStation.stopSequence"
            [dropingStationSeq]="dropingStation.stopSequence"
            [selectedDate]="calendarPickForm.get('day')?.value"
            [selectedTime]="calendarPickForm.get('time')?.value" (closeCardEvent)="closeCardEvent.emit()" />

            <div class="flex justify-between items-center bg-gray-200 rounded-xl p-2">
              <app-rating [rating]="line.rating" />
              <mot-button [matTooltip]="alreadyRatedText" matTooltipPosition="above" [matTooltipDisabled]="!isRatedLine"
                [disabled]="!!isRatedLine" [text]="rateText" (onClick)="openLineRatingPopUp(line.rating)" ariaHaspopup="dialog"
                buttonClass="!h-6 !bg-transparent" />
              </div>
            </form>

            <!-- <div class="sticky bottom-0 p-3 flex flex-col gap-4 z-50 bg-white">
              <mot-button buttonClass="!bg-primary w-full !text-white !py-6 !rounded-lg !align-middle" [text]="startTackText"
                icon="location-arrow" (onClick)="navigateToLine()" />
              </div>
            </div> -->
